module.exports = __webpack_public_path__ + "static/images/4122bc2e79139748564ead9d52e73f91.svg";